import React, { useState, useRef, useEffect } from "react";
import ReceptionImage from "../../../assets/history-image-1.jpg";
import "./HistoryImage1.css";

const HistoryImageSnaithe = () => {
  const [showSecondBox, setShowSecondBox] = useState(false);
  const secondBoxRef = useRef();
  const mainImageRef = useRef();

  useEffect(() => {
    if (showSecondBox && secondBoxRef.current) {
      secondBoxRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [showSecondBox]);

  const handleScrollDownAndToggle = () => {
    setShowSecondBox(true);
  };

  const handleCloseSecondBox = () => {
    setShowSecondBox(false);

    if (mainImageRef.current) {
      mainImageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="history-snaithe-1-parallax-container">
      <img
        className="history-snaithe-1-parallax-image"
        src={ReceptionImage}
        alt="History of Snaithe"
        ref={mainImageRef}
      />
      {!showSecondBox && (
        <button
          className="toggle-button5 show"
          onClick={handleScrollDownAndToggle}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
            >
              <path
                d="M41.25 24C41.25 24.1989 41.171 24.3897 41.0303 24.5303C40.8897 24.671 40.6989 24.75 40.5 24.75H24.75V40.5C24.75 40.6989 24.671 40.8897 24.5303 41.0303C24.3897 41.171 24.1989 41.25 24 41.25C23.8011 41.25 23.6103 41.171 23.4697 41.0303C23.329 40.8897 23.25 40.6989 23.25 40.5V24.75H7.5C7.30109 24.75 7.11032 24.671 6.96967 24.5303C6.82902 24.3897 6.75 24.1989 6.75 24C6.75 23.8011 6.82902 23.6103 6.96967 23.4697C7.11032 23.329 7.30109 23.25 7.5 23.25H23.25V7.5C23.25 7.30109 23.329 7.11032 23.4697 6.96967C23.6103 6.82902 23.8011 6.75 24 6.75C24.1989 6.75 24.3897 6.82902 24.5303 6.96967C24.671 7.11032 24.75 7.30109 24.75 7.5V23.25H40.5C40.6989 23.25 40.8897 23.329 41.0303 23.4697C41.171 23.6103 41.25 23.8011 41.25 24Z"
                fill="#000000"
              />
            </svg>{" "}
          </svg>
        </button>
      )}
      <div
        className={`snaithe-history-page-info ${
          showSecondBox ? "show" : "hide"
        }`}
        ref={secondBoxRef}
      >
        <div className="text-container-22">
          <div className="title1">Snáithe</div>
          <h2 className="box-second-titles1">
            The Weaver of Trust, Stitching Innovation into the Fabric of Time.
          </h2>
          <div className="box-1-text1">
            Mr. Bilal Mian, driven by the determination exhibited by his
            great-grandfather, grandfather, and his own father, achieved
            remarkable success through unwavering dedication and diligent work.
            <br />
            <br />
            Regarding Bilal's ancestry, allow me to provide a brief overview of
            the history of my human lineage, the hijra race.
            <br />
            <br />
            Let's journey back in time to explore the lineage that traces back
            to 20 centuries ago, beginning from the era of the Holy Prophet
            Muhammad (peace and blessings be upon him). I'll share with you as
            much information as has been passed down through the generations,
            acknowledging that there may be gaps in certain years. Nonetheless,
            I'll present the information that I have in order to provide you
            with an understanding of this lineage.
            <br />
            <br />
            I'll commence from this point to facilitate an easier grasp of the
            initial stages, starting with Mr. Hazrat Zayd bin Haritha, the 19th
            great-grandfather, and moving onward to my 1st father, Mr. Mian
            Muhammad Sharif.
          </div>
          <h2 className="box-second-titles1">
            The hallowed odyssey gracefully unveils itself as follows:
          </h2>
          <div className="box-1-text1">
            In the midst of their revered lifetimes and profoundly blessed
            encounters with the supreme Messenger, Muhammad upon whom be the
            most sublime peace and abundant blessings, the seal of Prophets,
            Muhammad (Peace be upon him).
            <br />
            <br />
            Hazrat Muhammad (peace be upon him), known as Prophet, Muhammad
            (Peace be upon him), was born in Mecca, present-day Saudi Arabia.
            His birth took place on the 12th day of Rabi' al-Awwal, which
            corresponds to the year 570 or 571 CE in the Gregorian calendar. His
            full name is Muhammad ibn Abdullah ibn Abd al-Muttalib.
            <br />
            <br />
            Prophet, Muhammad (Peace be upon him), received his initial
            revelation from Allah (God) through the Angel Gabriel (Jibril) at
            the age of 40 while meditating in the cave of Hira, near Mecca. This
            event marked the commencement of his prophetic mission and the
            unveiling of the holy scripture, the Quran. Muhammad's mission
            centered on conveying the principles of monotheism, social justice,
            compassion, and moral values to humanity.
            <br />
            <br />
            The subsequent 23 years of his life were devoted to preaching and
            disseminating the message of Islam, both in Mecca and later in
            Medina, where he relocated due to opposition and persecution from
            Meccan leaders. The migration from Mecca to Medina, known as the
            Hijra, occurred in 622 CE, marking the inception of the Islamic
            lunar calendar.
            <br />
            <br />
            Prophet, Muhammad (Peace be upon him), continued to lead the Islamic
            community in Medina, establishing a model of governance and
            spiritual practice. Beyond his role as a spiritual leader, he also
            served as a statesman, judge, and military commander. During this
            period, he participated in various battles to safeguard the
            fledgling Muslim community.
            <br />
            <br />
            In the year 632 CE, Prophet, Muhammad (Peace be upon him), the final
            pilgrimage, known as the Farewell Pilgrimage, took place. During
            this pilgrimage, he delivered a notable Farewell Sermon, emphasizing
            unity, equality, and social justice among believers.
            <br />
            <br />
            Prophet, Muhammad (Peace be upon him), passed away on the 12th day
            of Rabi' al-Awwal, 632 CE, in Medina. His departure marked the end
            of his earthly life, yet his teachings, the Quran, and the
            traditions (Hadith) he left behind continue to guide and inspire
            Muslims worldwide. He holds the esteemed position of the last and
            ultimate prophet in Islam and remains an exemplar of piety,
            morality, and compassion.
          </div>
          <h2 className="box-second-titles1">The lineage is as follows:</h2>
          <div className="box-1-text1">
            Genealogical Lineage of Mr. Bilal Mian and His Ancestors
            <br />
            The lineage is a tapestry woven through time, intertwining with
            moments of valor, entrepreneurship, and steadfast commitment. As we
            trace the journey of Mr. Bilal Mian's ancestors, the legacy comes
            alive, enriched with resilience and dedication.
            <br />
            <br />
            19th Great-grandfather: Hazrat Zayd bin Haritha
            <br />
            Revered for his martyrdom and unwavering loyalty to faith, Hazrat
            Zayd bin Haritha stood shoulder to shoulder with the Prophet
            Muhammad (Peace be upon him). The Prophet, in turn, heralded Hazrat
            Zayd bin Haritha's martyrdom, a testament to his devotion. <br />
            <br />
            <br />
            18th Great-grandfather: Hazrat Osama bin Zayd
            <br />
            Appointed by the Prophet Muhammad (Peace be upon him) as a leader in
            the Battle of Uhud, Hazrat Osama bin Zayd's courage and dedication
            shone brightly. He emerged as a beacon of valor during challenging
            times.
            <br />
            <br />
            17th Great-grandfather: Hazrat Muhammad bin Osama
            <br />
            Continuing the legacy of his forefathers, Hazrat Muhammad bin Osama
            upheld their honor and principles. His contributions forged a bridge
            between the past and the future.
            <br />
            <br />
            16th Great-grandfather: Hazrat Muhammad Hussain
            <br />
            An indelible mark in history was etched by Hazrat Muhammad Hussain
            through his steadfast contributions to the faith. His legacy added
            to the lineage's narrative.
            <br />
            <br />
            15th Great-grandfather: Hazrat Muhammad Sadiq
            <br />
            Upholding the noble heritage with unwavering devotion, Hazrat
            Muhammad Sadiq exemplified the virtues instilled through
            generations.
            <br />
            <br />
            14th Great-grandfather: Mian Muhammad Ahmed <br />
            Embarking on a journey of entrepreneurial success, Mian Muhammad
            Ahmed laid the foundation for future generations. This marked the
            inception of the lineage's engagement in business and trade.
            <br />
            <br />
            13th Great-grandfather: Mian Ahmed Mubarak <br />
            A torchbearer of the family's entrepreneurial legacy, Mian Ahmed
            Mubarak advanced with determination. His efforts added to the
            lineage's prosperity.
            <br />
            <br />
            12th Great-grandfather: Mian Muhammad Karim <br />
            Carrying forward the torch of family values, Mian Muhammad Karim
            expanded their business endeavors. His commitment and management
            propelled the lineage towards growth and success.
            <br />
            <br />
            11th Great-grandfather: Mian Muhammad Jalil <br />
            Cultivating business acumen, Mian Muhammad Jalil added to the
            narrative of success. His dedication to keeping the family united
            while nurturing visions underscored his significance.
            <br />
            <br />
            10th Great-grandfather: Mian Muhammad Wasih <br />
            Carrying forward the entrepreneurial spirit and vision, Mian
            Muhammad Wasih fostered growth. Their footsteps echoed in the
            lineage's progression.
            <br />
            <br />
            9th Great-grandfather: Mian Muhammad Saim <br />
            Contributing to the family's legacy, Mian Muhammad Saim shaped their
            business journey. Their honesty and passion fortified the lineage's
            businesses.
            <br />
            <br />
            8th Great-grandfather: Mian Muhammad Saleem <br />
            Distinguished both as a military commander and a fervent adherent of
            Islam, Mian Muhammad Saleem's legacy mirrored his passion for faith.
            Serving under Salahuddin Ayyubi, his dedication left an indelible
            mark.
            <br />
            <br />
            7th Great-grandfather: Mian Muhammad Barkat Extending services to
            Sultan Ertuğrul Bey, Mian Muhammad Barkat left behind a legacy of
            wisdom and achievement. His business acumen reverberated through the
            lineage.
            <br />
            <br />
            6th Great-grandfather: Mian Muhammad Sabir With unwavering
            commitment, Mian Muhammad Sabir embraced entrepreneurship. His
            dedication further strengthened the ethnic and family heritage,
            nurturing a thriving business legacy.
            <br />
            <br />
            5th Great-grandfather: Mian Baba Ira Continuing the legacy, Mian
            Baba Ira contributed to enduring success. Expanding agricultural
            endeavors and further developing businesses, he carved a path for
            generations to follow.
            <br />
            <br />
            4th Great-grandfather: Mian Rahmat Elhi Enduring in business, Mian
            Rahmat Elhi fostered growth and resilience. Launching trade with the
            British East India Company in 1758, he marked a turning point in the
            lineage's trajectory.
            <br />
            <br />
            3rd Great-grandfather: Mian Elahi Bakhsh Pioneering the lineage's
            entrepreneurial heritage, Mian Elahi Bakhsh paved the way for the
            future. Establishing the business with the British East India
            Company in 1807, he worked responsibly in the family forest area,
            and their foray into furniture manufacturing marked a significant
            milestone.
            <br />
            <br />
            3rd Great-grandfather: Mian Elahi Bakhsh Pioneering the lineage's
            entrepreneurial heritage, Mian Elahi Bakhsh paved the way for the
            future. Establishing the business with the British East India
            Company in 1807, he worked responsibly in the family forest area,
            and their foray into furniture manufacturing marked a significant
            milestone.
            <br />
            <br />
            1st Father: Mian Muhammad Sharif A pivotal figure who upheld the
            legacy, Mian Muhammad Sharif's migration from India to Pakistan in
            1947 marked a defining moment. Initiated an automobile business in
            1948, he propelled the lineage into modern times, manufacturing
            spare parts and contributing to the assembly of agricultural
            equipment, tractors, and vehicles.
            <br />
           </div>

          <h2 className="box-second-titles1">Legacy Unveiled: </h2>
          <div className="box-1-text1">
            Moving to the 8th great-grandfather, Mr. Mian Muhammad Saleem, he
            distinguished himself as a military commander under Salahuddin
            Ayyubi's leadership. I would like to mention my eighth grandfather
            here and tell you a little bit about him se below.
            <br />
            <br />
            Let me also introduce a prominent Muslim leader.
            <br />
            <br />
            Salahuddin Ayyubi, also known as Saladin, stands as a significant
            Muslim military leader and sultan during the medieval era. He was
            born in approximately 1137 CE in Tikrit, Iraq. His most renowned
            achievement involved his role in the Crusades, particularly his
            efforts to reclaim Jerusalem from Christian Crusader forces.
            <br />
            <br />
            Saladin's most pivotal moment was the recapture of Jerusalem in 1187
            during the Third Crusade. His forces triumphed over the Crusader
            army led by King Guy of Jerusalem at the Battle of Hattin in July
            1187. This victory paved the way for the eventual retrieval of
            Jerusalem in October of the same year.
            <br />
            <br />
            Saladin's approach to warfare was characterized by chivalry and
            honor, earning him respect even from his adversaries. Upon capturing
            Jerusalem, he granted safe passage to Christians who could not
            afford to pay for their release. This contrasted with the events of
            1099, when the Crusaders took Jerusalem through a massacre.
            <br />
            <br />
            Saladin's influence extended beyond military campaigns. He
            established the Ayyubid dynasty, which ruled over an extensive
            empire stretching from Egypt to Syria. Saladin passed away on March
            4, 1193, in Damascus, Syria, around the age of 55. His legacy
            resonates not only in military and political spheres but also in
            culture, religion, and ongoing interactions between East and West.
          </div>
          <h2 className="box-second-titles1">Continuing the Legacy: </h2>
          <div className="box-1-text1">
            Tracing the Journey to Our 8th Great-Grandfather, Mr. Mian Muhammad
            Saleem - A Path of Commitment and Triumph Alongside Sultan Ertuğrul
            Bey"
          </div>
          <h2 className="box-second-titles1">As for your sentence: </h2>
          <div className="box-1-text1">
            "His unwavering dedication extended further to our 8th
            great-grandfather, Mr. Mian Muhammad Saleem. He expanded his
            contributions by aligning himself with Sultan Ertuğrul Bey, offering
            invaluable strategies and achieving notable triumphs.".
          </div>
          <h2 className="box-second-titles1">
            Allow me to introduce another significant Muslim leader:
          </h2>
          <div className="box-1-text1">
            Sultan Ertuğrul Bey, also known as Ertuğrul Ghazi, is a historical
            figure pivotal in the establishment of the Ottoman Empire. He was
            born in 1191 CE in Söğüt, which is modern-day Turkey. He is notably
            the father of Osman I, the founder of the Ottoman dynasty.
            <br />
            <br />
            While Ertuğrul Ghazi's exact date of death is not definitively
            recorded, it is generally believed to have occurred in 1281 CE. His
            role in expanding the territory controlled by his tribe, the Kayı
            tribe, laid the foundation for later conquests that led to the
            formation of the Ottoman Empire.
            <br />
            <br />
            It's important to acknowledge that Ertuğrul Ghazi's life is
            interwoven with legends and stories, and historical details may have
            been embellished over time. The popular Turkish series "Ertuğrul"
            has contributed to the renewed interest in his life and the early
            history of the Ottoman Empire.
          </div>

          <h2 className="box-second-titles1">
            Forging the Future: Snáithe's Odyssey of Innovation, Trust, and
            Excellence
          </h2>
          <div className="box-1-text1">
            In the year 1807, Bilal's lineage witnessed a significant transition
            when his 3rd great-grandfather assumed the mantle of leadership for
            the family enterprise, inheriting it from his father. This legacy
            evolved further in the 18th century, as Bilal's great-grandfather
            diversified the business into agriculture. Harnessing fertile lands,
            they cultivated a variety of crops including rice, wheat, cotton,
            and sugarcane. It was in the same year, 1848, that the family
            ventured into the realm of catering for the British Army,
            concurrently establishing a furniture factory fueled by their
            private forests. This endeavor was initiated and carried forward by
            Bilal's grandfather and his father.
            <br />
            <br />
            In the domain of unwavering dedication and limitless potential
            emerges Snáithe—a visionary entity deeply rooted in Sweden, poised
            to redefine diverse sectors. Firmly founded on a bedrock of
            innovation and committed to nurturing trust, Snáithe stands as an
            exemplar of excellence across realms encompassing business,
            industry, governance, education, and technology. These principles
            are woven into Bilal's very essence, epitomizing hard work,
            progress, unwavering commitment, and the global impact of his
            endeavors.
            <br />
            <br />
            Bilal's entrepreneurial prowess is underpinned by a legacy that not
            only bolsters his resolve but also empowers him with the fortitude
            to forge ahead and flourish.
            <br />
            <br />
            Bilal Mian stands unwavering, poised to immortalize his family's
            venerable heritage within the chronicles of business history,
            ensuring its abiding influence not solely within the span of his own
            life but extending far into the future. Through the corridors of
            time, an illustrious lineage unfurls, intricately weaving threads of
            valor, entrepreneurial acumen, and steadfast dedication. This grand
            odyssey culminates splendidly with the emergence of a visionary
            luminary - none other than Bilal Mian himself. His adroit navigation
            of Snáithe's trajectory marks a pivotal juncture, heralding an era
            of profound transformation characterized by unswerving trust and
            groundbreaking innovation across a myriad of industries.
            <br />
            <br />
            Witness Bilal Mian, the virtuoso at the helm of Snáithe, embodying
            the seamless fusion of visionary leadership, limitless innovation,
            steadfast trust, and unwavering determination.
            <br />
            <br />
            Moreover, the succeeding generations of Bilal will dutifully
            perpetuate their ancestral business legacy.
            <br />
            <br />
            Bilal's entrepreneurial acumen is propelled by his legacy, a force
            that fortifies his mettle and imbues him with the audacity to press
            onward and thrive.
            <br />
            <br />
            This intricate tapestry of history interlaces epochs with meticulous
            precision, immersing them in the bedrock of unwavering commitment,
            the radiance of entrepreneurial fervor, and the resolute courage
            that forges an everlasting narrative - one that leaves an indelible
            mark on the canvas of inspired leadership. As this legacy endures,
            it encapsulates the essence of assiduous labor, profound affection,
            and comprehensive understanding - qualities that resonate
            universally, transcending the confines of industry and beckoning
            every individual to comprehend its potency and significance as it
            traverses the journey of the next five centuries.
          </div>
          <h2 className="box-second-titles1">
            Pioneering the Path Ahead: Illuminating Snáithe's Odyssey
          </h2>
          <div className="box-1-text1">
            Our voyage stands as a testament to the core values that propel us
            ahead—values anchored in integrity, creativity, and steadfast
            resolve. Snáithe is more than a mere corporate entity; it symbolizes
            a dedication to sculpting a horizon where opportunities know no
            bounds. Our extensive array of services spans a myriad of sectors,
            ranging from the dynamic landscapes of IT and AI technology to
            Construction and Landscape Infrastructure, Media Streaming and
            Broadcasting Solutions, the Automotive Industry, Cryptocurrency and
            Mining, Fitness and Bodybuilding, Manufacturing, Vehicle, Furniture,
            and Wood industries. Our reach extends to innovative platforms for
            vehicle rentals, auctions, and bids.
          </div>
          <h2 className="box-second-titles1">
            Upholding Trust: Our Sacred Obligation in Every Pursuit{" "}
          </h2>
          <div className="box-1-text1">
            Trust forms the bedrock upon which Snáithe proudly stands. We
            acknowledge the pivotal role that trust plays in nurturing profound
            relationships and propelling advancement. Every stride we take is
            underpinned by an unyielding duty to those who rely upon us. As we
            navigate uncharted territories, spanning the cryptocurrency
            industry, fitness and wellness sector, as well as the dynamic world
            of auction and bidding platforms, Snáithe remains steadfast in
            safeguarding the principles that have garnered the trust of
            countless individuals and entities.
          </div>
          <h2 className="box-second-titles1">
            Unleashing Innovation: The Unswerving Dedication of Snáithe{" "}
          </h2>
          <div className="box-1-text1">
            Innovation is not merely an abstract concept at Snáithe—it is the
            very essence of our existence. We amalgamate state-of-the-art
            technology with a human touch, crafting solutions that transcend
            functionality to deliver unparalleled experiences. Our steadfast
            commitment to pushing boundaries positions us at the vanguard of
            industries, where we envision, adapt, and flourish within a
            perpetually evolving landscape.
          </div>
          <h2 className="box-second-titles1">
            A Glimpse into the Morrow: Empowering Aspirations, Enriching
            Realities{" "}
          </h2>
          <div className="box-1-text1">
            As we embark on this audacious expedition, our gaze remains
            steadfast on a horizon where Snáithe epitomizes transformative
            eminence. Bound by our commitment to empower aspirations and enhance
            realities, we extend a cordial invitation for you to join us in
            coalescing a tomorrow where innovation knows no restraints, and
            trust remains unshakable.
            <br />
            <br />
            Snáithe - weaving the tapestry of trust, one strand of innovation at
            a time.
            <br />
            <br />
            Conclusion: A Vision of Enduring Commitment
            <br />
            <br />
            As our journey stretches toward tomorrow's horizon, Snáithe's
            commitment remains resolute—empowering dreams, enriching realities.
            Bilal's vision beckons individuals to shape a future free from
            constraints, where innovation and trust intertwine to forge a
            brighter tomorrow.
          </div>
          <button className="close-button5" onClick={handleCloseSecondBox}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="68"
              height="68"
              viewBox="0 0 68 68"
              fill="none"
            >
              <path
                d="M46.1978 21.8024C46.3384 21.9431 46.4174 22.1338 46.4174 22.3327C46.4174 22.5317 46.3384 22.7224 46.1978 22.8631L35.0608 34L46.1978 45.1369C46.3384 45.2776 46.4174 45.4683 46.4174 45.6673C46.4174 45.8662 46.3384 46.0569 46.1978 46.1976C46.0571 46.3382 45.8663 46.4173 45.6674 46.4173C45.4685 46.4173 45.2777 46.3382 45.1371 46.1976L34.0002 35.0607L22.8632 46.1976C22.7226 46.3382 22.5318 46.4173 22.3329 46.4173C22.134 46.4173 21.9432 46.3382 21.8026 46.1976C21.6619 46.0569 21.5829 45.8662 21.5829 45.6673C21.5829 45.4683 21.6619 45.2776 21.8026 45.1369L32.9395 34L21.8026 22.8631C21.6619 22.7224 21.5829 22.5317 21.5829 22.3327C21.5829 22.1338 21.6619 21.9431 21.8026 21.8024C21.9432 21.6618 22.134 21.5827 22.3329 21.5827C22.5318 21.5827 22.7226 21.6618 22.8632 21.8024L34.0002 32.9393L45.1371 21.8024C45.2777 21.6618 45.4685 21.5827 45.6674 21.5827C45.8663 21.5827 46.0571 21.6618 46.1978 21.8024Z"
                fill="#000000"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HistoryImageSnaithe;
